import ImageService from '@/services/ImageService'  
import GLTFService from '@/services/GLTFService' 
 
import AppStore from 'src/store/app'
import { HOME, PATHS, EVENTS } from '@/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'

import { clamp, map, DEG_TO_RAD } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from '@/helpers/EventEmitter'
import Communicator from '@/helpers/Communicator'
import {DoubleSpring} from '@/helpers/Spring'
  
import BaseGroup from '@/components/stage/common/base_group'
 
import gsap from 'gsap'
import dat from 'dat.gui' 

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'

// displacement
import vert_morph from '@/shaders/displacement/vertex_morph.glsl'
import vert_before_morph from '@/shaders/displacement/vertex_before_morph.glsl'


const Events = {}
 

class CameraGroup extends BaseGroup {

  constructor(config) { 

    super(config) 

    this.Events = Events
    Object.assign(this, EventEmitter)

    this.friction = config.friction || 1


    const home = AppStore.state.home
    const section = home.sections[home.section_index]
    const tgCameraDefaults = Env.mobile ? section.mobile.camera : section.camera

    this.tweenObj = {
      pointerClamp: 1
    }

    this.wiggle = {
      clamp: 1, // clamp based on promity to camera along z 
      counter: 0,
      speed: 0.01,
      position: {
        x: 0,
        y: 0,
        z: 0
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0
      }
    }

    this.base_duration = AnimationConfig.home.section.duration
    this.base_ease = AnimationConfig.home.section.ease
    this.expoOut = gsap.parseEase("expo.out")

    this.options = {
      
      fov: 60,
      
      center: new THREE.Vector3( 0, 0, 0 ),

      offset: {
        position: {
          z: 0
        }
      },
      
      position: {
        x: tgCameraDefaults.position.x,
        y: tgCameraDefaults.position.y,
        z: tgCameraDefaults.position.z
      },
      
      rotation: {
        x: tgCameraDefaults.rotation.x,
        y: tgCameraDefaults.rotation.y,
        z: tgCameraDefaults.rotation.z
      },

      content: {
        position: {
          x: 0
        }
      },

      pointer: { 
        x: 0,
        y: 0,
        z: 0,

        spring1: { 
          maxSpeed: 20,
          damping: 0.9,
          accelerationMultiplier: 0.03
        },

        spring2: {
          maxSpeed: 20,
          damping: 0.8,
          accelerationMultiplier: 0.02
        },

        tg: {
          x: 0,
          y: 0,
          z: 0
        },
        max: {
          x: (Env.desktop ? 20 : 10),
          y: (Env.desktop ? 5 : 30),
          z: 0
        }
      } 
    }
    
    this.updateClamp(this.options.position.z, section.index) 
    this.setup()
    this.resize() 
  }

  setup() {

    this.doubleSpringX = new DoubleSpring(this.options.pointer.spring1, this.options.pointer.spring2)
    this.doubleSpringY = new DoubleSpring(this.options.pointer.spring1, this.options.pointer.spring2)

    this.camera = new THREE.PerspectiveCamera( this.options.fov, window.innerWidth / window.innerHeight, 0.01, 1000 ) 
    this.cameraContainer = new THREE.Object3D()
    this.camera.position.z = 10
    this.cameraContainer.add( this.camera )
    this.add( this.cameraContainer ) 

    // this.addGUI()
  }

  updateClamp(presetZ, index){
    const sections = AppStore.state.home.sections
    const maxZ = Math.max.apply(Math, sections.map( section => { return section.camera.position.z } ) ) 
    const proxityClamp = map( presetZ, 3, 5, 0.75, 1)
    const welcomeSectionClamp = (index === 0 || index === (sections.length-1)) ? 0.01 : 1 
    const duration = this.getDuration(2)
    const tgClamp = (proxityClamp * welcomeSectionClamp) 
    gsap.to(this.wiggle, duration, { 
      clamp : tgClamp,  
      ease: 'expo.inOut'  
    })
  }
 
  // addGUI() { 

  //   if(this.gui){ 

  //     let cameraFolder = this.gui.addFolder('Camera')
      
  //     let spring1 = cameraFolder.addFolder('spring1') 
  //     spring1.add(this.options.pointer.spring1, 'maxSpeed', 0, 100).onChange(this.onGUIChange)
  //     spring1.add(this.options.pointer.spring1, 'damping', 0, 1).step(0.01).onChange(this.onGUIChange)
  //     spring1.add(this.options.pointer.spring1, 'accelerationMultiplier', 0, 1).step(0.01).onChange(this.onGUIChange)
      
  //     let spring2 = cameraFolder.addFolder('spring2')
  //     spring2.add(this.options.pointer.spring2, 'maxSpeed', 0, 100).onChange(this.onGUIChange)
  //     spring2.add(this.options.pointer.spring2, 'damping', 0, 1).step(0.01).onChange(this.onGUIChange)
  //     spring2.add(this.options.pointer.spring2, 'accelerationMultiplier', 0, 1).step(0.01).onChange(this.onGUIChange)
  //   }
 
  // }

  updateGUI () {} 

  updateCamera(duration = AnimationConfig.home.section.duration, ease = AnimationConfig.home.section.ease, pushback=true ){
  
    const home = AppStore.state.home 
    if( home.mode === HOME.MODES.DEFAULT ){

      const current_section = home.current_section 
      let preset = Env.mobile ? current_section.mobile.camera : current_section.camera
      Communicator.trigger(EVENTS.SCROLL_LOCK, true)
      let proxityClamp = (preset.position.z / this.maxZ) 
      this.updateClamp(preset.position.z, current_section.index) 

      gsap.to(this.options.position, this.getDuration(duration) , { 
        z : preset.position.z,  
        x : preset.position.x,  
        y : preset.position.y,  
        ease: ease
      })
 

      gsap.to(this.tweenObj, this.getDuration(duration) * 0.5 , { 
        pointerClamp : 0, 
        ease: 'power4.out'
      })
      gsap.to(this.tweenObj, this.getDuration(duration) * 0.5 , { 
        pointerClamp : 1, 
        delay: (this.getDuration(duration) * 0.5),
        ease: 'power4.in'
      })


      if(home.mode === HOME.MODES.DEFAULT && pushback && Env.desktop){ 
        gsap.to(this.options.offset.position, this.getDuration(duration) * 0.5 , { 
          z : -0.65, 
          ease: 'power4.in'
        })
        gsap.to(this.options.offset.position, this.getDuration(duration) * 0.5 , { 
          z : 0, 
          delay: (this.getDuration(duration) * 0.5),
          ease: 'power4.out'
        })
      }
     
      gsap.to(this.options.rotation, this.getDuration(duration) , {  
        x : preset.rotation.x, 
        y : preset.rotation.y, 
        z : preset.rotation.z, 
        ease: ease
      }) 
      gsap.to(this.options, this.getDuration(duration) , { 
        fov : preset.fov,  
        onUpdate: () => { 
          this.camera.fov = this.options.fov 
          this.camera.updateProjectionMatrix()
        },
        ease: ease
      })

      gsap.delayedCall( this.reduced_motion ? (duration / 2) : duration , () => { Communicator.trigger(EVENTS.SCROLL_LOCK, false) })

    }  

  }
  

  pointerMove(event){

    if(this.reduced_motion){
      return
    }

    if(Env.desktop){
      let easedY = this.expoOut( Math.abs(Pointer.polar.y) )
      let easedX = this.expoOut( Math.abs(Pointer.polar.x) )
      let rotMaxY = (this.options.pointer.max.y * -Pointer.polar.y * easedY) 
      let rotMaxX = (this.options.pointer.max.x * -Pointer.polar.x * easedX) 
      this.options.pointer.tg.y = rotMaxY * this.wiggle.clamp
      this.options.pointer.tg.x = rotMaxX * this.wiggle.clamp
    } else {
      if(Pointer.axis === Pointer.Constants.AXIS.X){
        let rotMaxY = this.options.pointer.max.y 
        let rotMaxX = this.options.pointer.max.x 
        let deltaSpeed = 0.25
        this.options.pointer.tg.x -= (Pointer.delta.x * deltaSpeed)
        this.options.pointer.tg.y -= (Pointer.delta.y * deltaSpeed)
        this.options.pointer.tg.x = clamp(this.options.pointer.tg.x * this.wiggle.clamp, -rotMaxY, rotMaxY)
        this.options.pointer.tg.y = clamp(this.options.pointer.tg.y * this.wiggle.clamp, -rotMaxX, rotMaxX)
      }
    } 
  }

  pointerStart(event){
    gsap.killTweensOf(this.options.pointer.tg )
  }

  pointerEnd(event){
    gsap.to(this.options.pointer.tg, 1, {
      x: 0,
      y: 0,
      ease: 'back.out(2)'
    })
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }



  // UPDATES -------------------------------------------------------------------
  
 
  tick(dt, force_render = false) {  

    if(!this.reduced_motion){

      // pointer interact
      if(Env.mobile || Env.tablet){
        if(Pointer.touching ){
          this.options.pointer.x += (this.options.pointer.tg.x - this.options.pointer.x) * 0.2
          this.options.pointer.y += (this.options.pointer.tg.y - this.options.pointer.y) * 0.2
        }  
      } else {
        //this.options.pointer.x += (this.options.pointer.tg.x - this.options.pointer.x) * 0.1
        //this.options.pointer.y += (this.options.pointer.tg.y - this.options.pointer.y) * 0.1

        this.options.pointer.y = this.doubleSpringY.process(this.options.pointer.tg.y)
        this.options.pointer.x = this.doubleSpringX.process(this.options.pointer.tg.x) 
      }
      
      // wiggle factor
      this.wiggle.position.z = (Math.sin(this.wiggle.counter) * 0.25) * this.wiggle.clamp
      this.wiggle.rotation.x = (Math.sin(this.wiggle.counter) * 5) * this.wiggle.clamp
      this.wiggle.rotation.y = (Math.sin(this.wiggle.counter) * 5) * this.wiggle.clamp

    }

    this.cameraContainer.position.y = (this.options.position.y  + (this.options.offset.position.z * 0.5))
    this.cameraContainer.position.z = this.options.offset.position.z 
    this.cameraContainer.rotation.x = (this.options.rotation.x + (this.options.pointer.y * this.tweenObj.pointerClamp) + this.wiggle.rotation.x ) * DEG_TO_RAD 
    this.cameraContainer.rotation.y = (this.options.rotation.y + (this.options.pointer.x * this.tweenObj.pointerClamp) + this.wiggle.rotation.y ) * DEG_TO_RAD
    this.cameraContainer.rotation.z = (this.options.rotation.z  ) * DEG_TO_RAD
    this.camera.position.z = (this.options.position.z + this.wiggle.position.z) 
    this.camera.position.x = (this.options.position.x + this.options.content.position.x )
    this.wiggle.counter += this.wiggle.speed 
  }

  resize() {
    let ww = window.innerWidth
    let wh = window.innerHeight
    if(this.camera){
      this.camera.aspect = ww / wh
      this.camera.updateProjectionMatrix()
    }
  } 

  destroy(){} 

  enter(){ }

  leave(){ }

  contentLeave(duration = this.getDuration(1.5), ease = 'back.inOut'){  
    gsap.to(this.options.content.position, { 
      duration: duration,
      x : 0, 
      ease: ease
    }) 
  }

  contentEnter(x, ease = 'elastic.out(0.5)' ){
    gsap.to(this.options.content.position, {
      duration: this.getDuration(2),
      x : x, 
      ease: ease 
    }) 
  }



  // HANDLERS -------------------------------------------------------------------

  onGUIChange = () => { 
    this.doubleSpringX.updateOptions(this.options.pointer.spring1, this.options.pointer.spring2)
    this.doubleSpringY.updateOptions(this.options.pointer.spring1, this.options.pointer.spring2)
  }


  // STATES -------------------------------------------------------------------

  /* modal states */
 
  modalNone(){
    this.contentLeave(2, 'power2.inOut')
    this.updateCamera(2, 'power2.inOut', false)
  }
  
  modalMenu(){

    const home = AppStore.state.home
    const current_section = home.current_section
    const sections = home.sections

    if(current_section.index === (sections.length-1)){
      return 
    }

    const menu = AppStore.state.menu
    let duration = this.getDuration(2) 
    let position = Env.mobile ? 0 : -(menu.camera.position.x + 1.3)
    let ease = Env.mobile ? 'expo.inOut' : 'expo.out'
    let mobileMult = Env.mobile ? 0 : 1
    this.contentEnter(position , ease ) 


    if(!Env.mobile){
      gsap.to(this.options.rotation, duration , {  
        x : menu.camera.rotation.x, 
        y : menu.camera.rotation.y, 
        ease: ease
      }) 
    }
    
    gsap.to(this.options.position, duration , { 
      z : menu.camera.position.z,  
      x : menu.camera.position.x * mobileMult,  
      y : menu.camera.position.y,  
      ease: ease
    })
    gsap.to(this.options, duration , { 
      fov : menu.camera.fov,  
      onUpdate: () => { 
        this.camera.fov = this.options.fov 
        this.camera.updateProjectionMatrix()
      }, 
      ease: ease
    })
  }

  checkJump(val, prev, dir){  
    let jump = (dir !== 0 && prev && Math.abs(val.index - prev.index) > 1) || this.reduced_motion 
    return jump
  }



  /* page states */

  routeLoading(){ } 
 
  routeHome(){ 
    this.contentLeave()
  } 

  routeOneStar(){  
    this.contentEnter( -(this.options.position.x - 1.3) ) 
     
  }

  routeTwoStar(){ 
    this.contentEnter( -(this.options.position.x - 1.3) )  
  }

  routeThreeStar(){ 
    this.contentEnter( -(this.options.position.x - 1.3) ) 
  }

  routeFourStar(){
    this.contentEnter( -(this.options.position.x - 1.3) )  
  }

  routeFiveStar(){  
    this.contentEnter( -(this.options.position.x - 1.3) )  
  }
  

  /* home states */
 
  welcome(val, prev){  
    let pushback = (prev && prev.index !== 6)
    this.updateCamera(this.base_duration, this.base_ease, pushback)
  } 
 
  ratingFive(val, prev, dir){
    const jump = this.checkJump(val, prev, dir)
    this.updateCamera(this.base_duration, this.base_ease, !jump) 
  } 

  ratingFour(val, prev, dir){
    const jump = this.checkJump(val, prev, dir)
    this.updateCamera(this.base_duration, this.base_ease, !jump) 
  } 
 
  ratingThree(val, prev, dir){
    const jump = this.checkJump(val, prev, dir)
    this.updateCamera(this.base_duration, this.base_ease, !jump) 
  }

  ratingTwo(val, prev, dir){
    const jump = this.checkJump(val, prev, dir)
    this.updateCamera(this.base_duration, this.base_ease, !jump) 
  } 
 
  ratingOne(val, prev, dir){
    const jump = this.checkJump(val, prev, dir) 
    this.updateCamera(this.base_duration, this.base_ease, !jump)
  } 

  cta(val){
    this.updateCamera()
  } 

}
 

export default CameraGroup